import { Texto, Horizontal } from '@gravitate-js/excalibrr'
import type { GroupCellRendererParams } from 'ag-grid-community'
import type { TransactionRow } from '../../../../../api/useFreight/types'
import { MultiCustomerFlag, NewVersionAvailableFlag } from '../flags'

/**
 * Cell renderer for order number column
 * Shows order number with warning indicator if needed
 */
export function OrderNumberRenderer(params: GroupCellRendererParams<TransactionRow>) {
  function getDifference() {
    const currentTotal = params.data?.total || 0
    const newVersionTotal = params.data?.new_version_total || 0
    const difference = newVersionTotal - currentTotal

    const formattedDifference = difference.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    })

    return formattedDifference
  }

  const isPosted = params.data?.status === 'posted'

  return (
    <Horizontal verticalCenter gap={4}>
      <Texto className='mr-1' weight='bold'>
        {params.value}
      </Texto>
      <MultiCustomerFlag isMultiCustomer={params.data?.is_multi_customer} />
      <NewVersionAvailableFlag
        newVersionAvailable={params.data?.new_version_available}
        difference={getDifference()}
        isPosted={isPosted}
      />
    </Horizontal>
  )
}
